// extracted by mini-css-extract-plugin
export default {"image":"dK_dy","industry":"dK_mQ","industryTitle":"dK_mR"};